import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  auditDetails: any;
}

const initialState: InitialState = {
  auditDetails: {}
};

export const auditSlice = createSlice({
  name: "audits",
  initialState,
  reducers: {
    setAuditDetails: (state: any, action: PayloadAction<any>) => {
      state.auditDetails = action.payload;
    }
  },
});

export const {
  setAuditDetails
} = auditSlice.actions;
